import { Link, useNavigate } from "react-router-dom";
import { Box, Typography, IconButton, Stack, Badge } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./header.css";
import Cart from '../assets/cart.png'
import Qr from '../assets/qrmark.png'
import { toast } from "react-toastify";
function VmInventoryHeader({
  title = "",
  subtitle = "",
  route = "/",
  height = "60px",
  marginTop = "0px",
  ShowQRFun,
  preCart
}) {
   const navigate = useNavigate()
  // Reusable truncation helper
 const totalCount =preCart&& preCart[0]&&preCart.reduce((total, item) => total + item.count, 0);
  const truncateText = (text, limit) => {
    if (!text) return "";
    return text.length <= limit ? text : `${text.substring(0, limit)}...`;
  };

    const goMyCart = ( totalCount) => {
      if( totalCount){
    localStorage.setItem("mycart", true);
 /*    mpCartClicked({
      EventName: mixpanelEvent,
      data: { ItemsInCart: cartItemsList, TotalCartValue: totalAmount },
    }); */
    navigate("/myCart");
      }
      else{
    toast.error(`${"Cart is Empty"}`, {
      position: "bottom-left",
      autoClose: 500,
      style: { backgroundColor: "#f35050ee", color: "#fff",bottom:"100px",fontWeight:"600"  },

    });
      }
  };
  return (
    <Box
      className="daalchini-header-color"
      sx={{
        height,
        display: "flex",
        alignItems: "center",
        px: 2,
        mt: marginTop,
        background:"#fae14b",
        position:"fixed",
            width: "100%",
    zIndex: "99",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        sx={{ width: "100%" }}
      >
        {/* Back Arrow */}
        <Box display={"flex"} width={"100%"}     justifyContent={"space-between"}>
        <Box display={"flex"}>
        <IconButton
          component={Link}
          to={route}
          size="small"
          aria-label="Go Back"
          sx={{ p: 0,mr:"10px" }}
        >
          <ArrowBackIcon
            sx={{
              fontSize: 22,
              color: "#583C43",
            }}
          />
        </IconButton>

        {/* Title + Subtitle */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Roboto",
              fontSize: "18px",
              fontWeight: 500,
              color: "#583C43",
              letterSpacing: "0.36px",
              lineHeight: "normal",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "220px", // control title width for truncation
            }}
          >
            {truncateText(title, 25)}
          </Typography>

          {subtitle && (
            <Typography
              variant="body2"
              sx={{
                fontSize: "13px",
                color: "rgba(88, 60, 67, 0.7)",
                lineHeight: "normal",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "280px",
              }}
            >
              {truncateText(subtitle, 35)}
            </Typography>
          )}


          
        </Box>
        </Box>
 <Box display="flex" alignItems="center">
      {/* 🛒 Cart Icon with Badge */}
      <Badge
        badgeContent={totalCount}
        color="error"
        overlap="circular"
        sx={{
          "& .MuiBadge-badge": {
            fontSize: "0.7rem",
            height: 18,
            minWidth: 18,
            top: "13px",
            right: "18px",
            backgroundColor: "#129a69",
          },
        }}
      >
        <img
          src={Cart}
          alt="Cart"
          onClick={() => goMyCart( totalCount)}
          style={{
            width: "40px",
            marginRight: "10px",
            cursor: totalCount ? "pointer" : "default",
           // opacity: totalCount ? 1 : 0.6,
          }}
        />
      </Badge>

     
      {/* 📱 QR Icon */}
      <img
        src={Qr}
        alt="QR Code"
        onClick={ShowQRFun}
        style={{
          width: "30px",
          height: "30px",
          cursor: "pointer",
        }}
      />
    </Box>
        </Box>
      </Stack>
    </Box>
  );
}

export default VmInventoryHeader;
